var render = function render(){var _vm=this,_c=_vm._self._c;return _c('El',_vm._b({attrs:{"minHeight":210,"mb":20}},'El',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }